export default [
  {
    path: '/',
    redirect:"/tjmain"
  },
  {
    path: '/tjmain',
    name: 'tjmain',
    hidden: true,
    noPermission: true,
    component: () => import('../views/tjmain')
  }
];
  